export interface ITab {
  /**
   * Header text for the tab.
   */
  header: string | React.ReactNode;

  /**
   * Content to render within the tab.
   */
  content: React.ReactNode;

  /**
   * Indicates if the tab is disabled. Defaults to false.
   */
  disabled?: boolean;

  /**
   * Control whether a tab is displayed.
   */
  visible?: boolean;
}

export interface ITabs {
  /**
   * Array of tabs to render.
   */
  tabs: ITab[];

  /**
   * Index of the active tab. Defaults to the first tab if not specified.
   */
  activeTabIndex?: number;

  /**
   * Size of the tabs. Can be 'small', 'medium', or 'large'.
   */
  size?: TabSize;

  /**
   * Determines if users are allowed to switch tabs.
   */
  allowToChangeTab?: boolean;

  /**
   * Optional custom CSS class for individual tab elements.
   */
  tabClassName?: string;

  /**
   * Optional custom CSS class for the Tabs container.
   */
  className?: string;

  /**
   * If true, show a mobile-only “modal” version of the tabs
   * on screens <= 768px. Defaults to true.
   */

  onTabChange?: (tabIndex: number) => void;
}

export enum TabSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
